/*
 * @Author: hehaishen
 * @Date: 2019-06-14 22:03:02
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2019-12-27 17:56:39
 * @Description:
 */
const routerArr = [
    {
        path: 'specialistInfo',
        component: (resolve) => require(["page/technicalSupport/specialistInfo/index.vue"], resolve),
        meta: { show: '1110', title: '客服管理' },
    },
    {
        path: 'specialistInfo/handle',
        component: (resolve) => require(["page/technicalSupport/specialistInfo/infoHandle.vue"], resolve),
        meta: { show: '1110', title: '新增编辑' },
    },
    {
        path: 'serviceOrder',
        component: (resolve) => require(["page/technicalSupport/serviceOrder/index.vue"], resolve),
        meta: { show: '1110', title: '会话工单' },
    },
    {
        path: 'serviceAccount',
        component: (resolve) => require(["page/technicalSupport/serviceAccount/index.vue"], resolve),
        meta: { show: '1110', title: '客服账号' },
    },
    {
        path: 'serviceAccount/serviceSet',
        component: (resolve) => require(["page/technicalSupport/serviceAccount/serviceSet.vue"], resolve),
        meta: { show: '1110', title: '客服账号设置' },
    },
];

export default routerArr;



// WEBPACK FOOTER //
// ./src/container/pages/technicalSupport/_res.js